export function leaflet_topojson(json) {
  if (json.type === 'Topology')
    for (var key in json.objects)
      L.GeoJSON.prototype.addData.call(this, topojson.feature(json, json.objects[key]))
  else
    L.GeoJSON.prototype.addData.call(this, json)
}
